import React, { Component } from 'react'
import Reader from '../../controller/Reader'


export default class DocsCatg extends Component {

	state = { 
        catg : []
    }


    componentDidMount() {

        this.getFx()

    }


    getFx = () => {
        
        const condition = {
            url : '/api/docs/list'
        }

        Reader(condition, res => {

            if(res.data !== null) {

                this.setState({

                    catg : res.data
                
                })

            }
        })
    }

    
    catgFx = (e) => {

        this.props.catgFx(e.target.id)

    }

    render() {
    	
		let postList = this.state.catg.map( post => {


            return (
                

                    <span id = { post._id } onClick = { this.catgFx } >

                        { post.title }
                    
                    </span>
				
            )
        })

    	
        return (
            	
			<div id='DocsCatgTxt'>

			
				{ postList }					
		
			</div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/docs/DocsCatg.js